import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setInitialPosition, forgotPassword } from '../../actions';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import { TextField, RaisedButton } from 'material-ui'
import locale from '../../common/locale'
import Cookies from 'universal-cookie';
const cookies = new Cookies();

export class ForgotPassword extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.props.setInitialPosition(window.innerHeight, window.innerWidth, 'f')
  };

  handleSubmit(data) {
    data.preventDefault();
    this.props.forgotPassword(this.refs.email.getValue(), cookies.get('locale'))
  }

  render() {
    const { client } = this.props
    const loc = cookies.get('locale')
    const errors = this.props.server.errors
    return (
      <div className='node child'
        style={{
        transform: `translate3d(
        ${client.x['f']}px,
        ${client.y['f']}px,
        0px)`, zIndex:`1`, color: `#5D5D5D`}}>

        <MuiThemeProvider>
          <i className="fas fa-envelope fa-5x" />
          <form onSubmit={this.handleSubmit}>
            <TextField floatingLabelText={locale.registered_email(loc)} ref="email"
              floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
              errorText={errors['email']}
              underlineFocusStyle={styles.underlineStyle} />
            <p />
            <RaisedButton label={locale.reset_password(loc)} type="submit" />
          </form>
        </MuiThemeProvider>
      </div>
    )
  }

}

const styles = {
  floatingLabelFocusStyle: {
    color: "#000000"
  },
  underlineStyle: {
    borderColor: '#000'
  }
}

const mapStateToProps = state => ({
  client: state.client,
  server: state.server
});

const mapDispatchToProps = {
  setInitialPosition,
  forgotPassword
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);



// WEBPACK FOOTER //
// ./src/components/SignupLogin/ForgotPassword.js